/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {collection, query, where, getDocs} from 'firebase/firestore';
import {Link} from 'react-router-dom';
import {db} from '../../../firebase';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface ReleaseProps {
  id: string,
  author: string,
  version: string,
  versionDate: Date,
}

const Releases = () => {
  const [releases, setReleases] = useState<ReleaseProps[]>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading) {
      const q =
        query(
            collection(db, 'releasesCreated'),
        );

      const fetchData = async () => {
        const querySnapshot = await getDocs(q);
        let newData: any[] = [];

        querySnapshot.forEach((doc) => {
          newData = [
            ...newData,
            {
              id: doc.id,
              author: doc.data().author,
              version: doc.data().version,
              versionDate: doc.data().versionDate,
            },
          ];
        });
        setReleases(newData);
        setLoading(false);
      };

      fetchData();
    }
  }, [releases, loading]);

  if (loading) {
    return (
      <Grid
        container
        spacing={4}
        style={{
          justifyContent: 'center',
          alignContent: 'center',
          textAlign: 'center',
        }}
      >
        <Grid item xs={12}>
          <CircularProgress
            style={{
              padding: '20em 0',
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      style={{
        justifyContent: 'center',
      }}
    >
      {releases &&
        releases.map((release: ReleaseProps, index: number) =>
          <Grid
            key={index}
            item xs={12}
            style={{
              paddingTop: '2em',
              maxWidth: '600px',
            }}
          >
            <Paper style={{
              padding: '1em 1em 1em 1em',
            }}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">
                    Autor: {release.author}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">
                    Data da Versão: {moment(release.versionDate).format('DD/MM/YYYY')}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">
                    Versão: {release.version}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Link to={`/telemedicine/releases/${release.id}`} color="inherit">
                    {release.id}
                  </Link>
                </Grid>
              </Grid>
            </Paper>
          </Grid>,
        )
      }
    </Grid>

  );
};

export default Releases;
